export { getStorageItem } from './get-storage-item';
export { setStorageItem } from './set-storage-item';
export { setStrictlyNecessaryStorageItem } from './set-strictly-necessary-storage-item';
